import { trimSlash } from "~/utils/miscellaneous";
import getLocalHostEnvConfig from "./hostEnv";
import { getEnvironmentConfigFromHostApp } from "~/lib/hostAppData";

export const mockEnvKey = "standalone";

export const deploymentEnvKeys = ["dev", "uat", "prod"];
const additionalEnvKeys = ["local", mockEnvKey];

export const envKeys = deploymentEnvKeys.concat(additionalEnvKeys);

export function getHostEnv() {
  const hostEnvConfig = getEnvironmentConfigFromHostApp();

  return hostEnvConfig
    ? hostEnvConfig.graphqlServer.match(/\bdev\b/)
      ? "dev"
      : hostEnvConfig.graphqlServer.match(/\buat\b/)
      ? "uat"
      : "prod"
    : null;
}

export function getDeployedEnv() {
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  return ["localhost", "127.0.0.1"].indexOf(hostname) > -1
    ? null
    : subdomain.includes("dev")
    ? "dev"
    : subdomain.includes("uat")
    ? "uat"
    : "prod";
}

export function getVueEnvConfig(env, hostEnv) {
  return {
    useMock: env == "standalone",
    services: {
      graphql: {
        url:
          env == "local"
            ? "http://localhost:4000/graphql/v1/invesco"
            : env == "standalone"
            ? "gql/"
            : trimSlash(hostEnv.graphqlServer) + "/graphql",
        type: "graphql",
      },
    },
  };
}

export default function (env) {
  const hostEnvKey = getHostEnv();
  env = env ?? hostEnvKey ?? "dev";

  const hostEnv =
    hostEnvKey != env
      ? getLocalHostEnvConfig(env)
      : getEnvironmentConfigFromHostApp();

  return {
    hostEnv,
    vueEnv: getVueEnvConfig(env, hostEnv),
  };
}
